import { defineComponent, inject, computed, provide, renderSlot } from "vue";
import locale from "../locale/en_US.js";
import { CONFIG_PROVIDER_LOCALE_INJECTION_KEY, CONFIG_PROVIDER_TELEPORT_RENDER_DISABLED_INJECT_KEY, CONFIG_PROVIDER_DIRECTION_INJECT_KEY } from "./injectionKeys.js";
import merge from "../../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/merge.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ConfigProvider",
  props: {
    locale: {},
    dir: {},
    teleportRenderDisabled: { type: Boolean },
    directivesProvides: {}
  },
  setup(__props) {
    const props = __props, defaultLocale = inject(CONFIG_PROVIDER_LOCALE_INJECTION_KEY, void 0), localeRef = computed(() => {
      const _localeProvideValue = props.directivesProvides && typeof props.directivesProvides == "object" ? Reflect.get(props.directivesProvides, CONFIG_PROVIDER_LOCALE_INJECTION_KEY) : void 0, _locale = (_localeProvideValue == null ? void 0 : _localeProvideValue.value) ?? props.locale;
      return merge({}, (defaultLocale == null ? void 0 : defaultLocale.value) ?? locale, _locale);
    }), directionRef = computed(() => props.dir || localeRef.value.dir), teleportRenderDisabledRef = computed(() => {
      const _teleportRenderDisabledProvideValue = props.directivesProvides && typeof props.directivesProvides == "object" ? Reflect.get(props.directivesProvides, CONFIG_PROVIDER_TELEPORT_RENDER_DISABLED_INJECT_KEY) : void 0;
      return (_teleportRenderDisabledProvideValue == null ? void 0 : _teleportRenderDisabledProvideValue.value) ?? props.teleportRenderDisabled ?? !1;
    });
    return provide(CONFIG_PROVIDER_DIRECTION_INJECT_KEY, directionRef), provide(CONFIG_PROVIDER_LOCALE_INJECTION_KEY, localeRef), provide(CONFIG_PROVIDER_TELEPORT_RENDER_DISABLED_INJECT_KEY, teleportRenderDisabledRef), (_ctx, _cache) => renderSlot(_ctx.$slots, "default");
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=ConfigProvider.js.map
